<template>

  <!-- Search Results Block -->
  <page-block
    bg-image-contain
    :bg-file="value.file"
    :bg-color="value.bgColor"
    class="search-results-block"
    :text-color="value.textColor"
    :text-align="value.textAlign"
    :width-class="value.widthClass"
    :overlay-class="value.paddingClass">

    <page-block-header
      no-element
      class="sbs-mb"
      :value="headerOptions"/>

    <div
      v-if="totalItems"
      class="d-grid grid-gap-3">

      <universal-link
        :key="item.id"
        v-for="item in news"
        :to="`/news-item/${item.slug}`">

        <search-result-card
          :value="item"
          type="Новость"
          class="hover-scale-2"/>

      </universal-link>

      <universal-link
        :key="item.id"
        v-for="item in events"
        :to="`/event/${item.slug}`">

        <search-result-card
          :value="item"
          type="Мероприятие"
          class="hover-scale-2"/>

      </universal-link>

    </div>

    <empty-status
      v-else
      size="lg"
      :loading="loading"
      message="Ничего не найдено"/>

  </page-block>

</template>

<script>

  import {mapState, mapGetters} from 'vuex';
  import PageBlock from '@src/components/page/page-block';
  import EmptyStatus from '@src/components/status/empty-status';
  import PageBlockHeader from '@src/components/page/page-block-header';
  import SearchResultCard from '@src/components/card/search-result-card';

  export default {
    name: 'search-results-block',
    props: {
      value: {
        type: Object,
        required: true,
      },
    },
    components: {
      PageBlock,
      EmptyStatus,
      PageBlockHeader,
      SearchResultCard,
    },
    computed: {
      ...mapState('vlNews', {
        news: 'items',
      }),
      ...mapState('vlEvents', {
        events: 'items',
      }),
      ...mapState('search', {
        query: 'query',
      }),
      ...mapGetters('search', {
        loading: 'loading',
        totalItems: 'totalItems',
      }),
      headerOptions() {

        const title = this.query
          ? `Поиск: ${this.query}`
          : 'Поиск';

        return {
          ...this.value,
          title,
        };
      },
    },
  };

</script>

<style lang="scss">

  .search-results-block {
    color: inherit;
  }

</style>
